import React, { useEffect, useRef, useState } from 'react';
import { DropdownPortal } from '../components/Dropdown/DropdownPortal';
import Icon, { IconType } from './Icon';

export interface IconButtonTemplateProps extends Omit<IconButtonProps, 'type'> {}

interface IconButtonProps {
  type: IconType;
  stroke?: string;
  text?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function IconButton({ type, text, stroke = 'stroke-body', className = '', onClick }: IconButtonProps) {
  const ref = useRef<HTMLButtonElement>(null);

  const [hovered, setHovered] = useState(false);
  const [rect, setRect] = useState({ left: 0, top: 0, width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setRect({ left: rect.left, top: rect.top, width: rect.width, height: rect.height });
  }, [hovered]);

  return (
    <button
      ref={ref}
      className={`${className} relative flex items-center justify-center rounded-2 p-2.5 -outline-offset-2 hover:bg-gray-default`}
      onKeyDown={event => event.stopPropagation()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={event => {
        if (onClick) {
          event.stopPropagation();
          onClick(event);
        }
      }}
    >
      <Icon type={type} stroke={stroke} size={'size-5'} />
      {text && hovered && (
        <DropdownPortal>
          <span
            style={{
              left: rect.left + rect.width / 2,
              top: rect.top - 4,
              transform: 'translate(-50%, -100%)',
            }}
            title={text}
            className='fixed z-50 -translate-x-full rounded-2 bg-gray-700 px-2 py-1 text-xs text-white'
          >
            {text}
          </span>
        </DropdownPortal>
      )}
    </button>
  );
}
